"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubHomeResponseSchema = exports.SubHomeWidgetItemScheme = exports.SubHomeInputScheme = void 0;
var zod_1 = require("zod");
var home_1 = require("./home");
/**
 * 서브홈 위젯 통합 호출
 * @see {@link https://yanolja.atlassian.net/wiki/x/DoASHQ}
 * */
exports.SubHomeInputScheme = zod_1.z.object({
    userLocation: zod_1.z
        .object({
        latitude: zod_1.z.number(),
        longitude: zod_1.z.number(),
        locationType: zod_1.z.string(),
        locationTime: zod_1.z.number(),
    })
        .optional(),
    localAccommodation: zod_1.z.object({
        checkInDate: zod_1.z.string(),
        checkOutDate: zod_1.z.string(),
        capacityAdults: zod_1.z.number(),
        childrenAges: zod_1.z.array(zod_1.z.number()),
    }),
    globalAccommodation: zod_1.z.object({
        checkInDate: zod_1.z.string(),
        checkOutDate: zod_1.z.string(),
        rooms: zod_1.z.array(zod_1.z.object({
            capacityAdults: zod_1.z.number(),
            childrenAges: zod_1.z.array(zod_1.z.number()),
        })),
    }),
});
exports.SubHomeWidgetItemScheme = zod_1.z.object({
    api: zod_1.z.object({ method: zod_1.z.string(), url: zod_1.z.string() }),
    data: zod_1.z.any(),
    refreshPolicy: zod_1.z.enum([home_1.RefreshPolicy.ON_REQUEST, home_1.RefreshPolicy.ON_VISIBLE]),
    target: zod_1.z.string(),
    type: zod_1.z.string(),
});
exports.SubHomeResponseSchema = zod_1.z.object({
    title: zod_1.z.string().nullish(),
    widgets: zod_1.z.array(exports.SubHomeWidgetItemScheme),
});
